module.exports = __webpack_public_path__ + "media/images/sp_preview-d220117a2218a591716b5ce8075975d9.png";